import React from "react";
import { twMerge } from "tailwind-merge";
import { Element } from "../base";

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export default function CardFooter({ className, children }: IProps) {
    return (
        <Element
            className={twMerge(
                "bm-card-footer",
                "relative",
                "flex flex-wrap items-center",
                "text-[12px] text-[#666]",
                'leading-[16px]',
                'mt-[4px]',
                "[&>:not(:first-child)]:ml-[16px] [&>:not(:first-child)]:shrink-0",
                className
            )}
        >
            {children}
        </Element>
    );
}
